<template>
  <div>
    <table class="table table-sm">
      <thead></thead>
      <tbody>
        <tr>
          <td>RESIDENTE</td>
          <td>
            <strong>{{ service.resident_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>SERVIÇO</td>
          <td>
            <strong>{{ service.service_description }}</strong>
          </td>
        </tr>
        <tr>
          <td>RESPONSÁVEL</td>
          <td>
            <strong>{{
              professionalClassCouncilValue({
                id: service.user_professional_class_council_id,
                name: service.user_name,
                profile: service.user_profile_name,
                office: service.user_office,
                cpf: service.user_cpf,
                value: service.user_professional_class_council_value,
              })
            }}</strong>
          </td>
        </tr>
        <tr>
          <td>DATA DO SERVIÇO</td>
          <td>
            <strong>{{ moment(service.date).format("DD/MM/YYYY") }}</strong>
          </td>
        </tr>
        <tr>
          <td>VENDA DO SERVIÇO</td>
          <td>
            <strong>R$ {{ formatPrice(String(service.value_sale)) }}</strong>
          </td>
        </tr>
        <tr>
          <td>QUANTIDADE</td>
          <td>
            <strong>{{ service.quantity }}</strong>
          </td>
        </tr>
        <tr>
          <td>TOTAL</td>
          <td>
            <strong>
              R$
              {{
                formatPrice(
                  parseInt(service.quantity) * parseFloat(service.value_sale)
                )
              }}
            </strong>
          </td>
        </tr>
        <tr>
          <td>DATA DO REGISTRO</td>
          <td>
            <strong>{{
              moment(service.created_at).format("DD/MM/YYYY HH:mm:ss")
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import {
  formatPrice,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

export default {
  name: "Details",

  props: {
    service: Object,
  },

  created() {},

  methods: {
    moment,
    professionalClassCouncilValue,
    formatPrice,
  },
};
</script>
